//Global Color Palette

export const Palette = {
  primary: "#27debf",
  text: "#fff",
  background: "#1F1F1F",
  card: "#272626",
  placeholder: "rgba(255, 255, 255, 0.7)",
};
